import { Checkbox, Col, Form, Icon, Input, Row } from 'antd'
import DangerousGoodsItem from '../../../components/Sales/Quotes/AddQuote/DangerousGoodsItem'
import CustomSpin from '../../../elements/CustomSpin'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import useDangerGoods from '../../../elements/Hooks/useDangerGoods'
import ShippingDetails from '../../../elements/ShippingDetails'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules, threeFormItemLayout } from "../../../modules/FormItems";
import { arrVal } from '../../../modules/Utils'
import React from 'react'

import { compose } from 'recompose'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'

function PackageForm (props) {
  const { packageObj, fetching, modalType, isLocked } = props
  const isNew = modalType === 'new'
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const isDangerous = getFieldValue('isDangerous')
  const [goods, setGoods] = useDangerGoods(
    arrVal(packageObj, 'dangerousGoods').length,
    [packageObj._rev],
    !isEmpty(packageObj._rev),
  )

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <Row>
          <FormSectionTitle title={'Package Details'}/>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'name '}>
              {getFieldDecorator('name', {
                initialValue: get(packageObj, 'name'),
                rules: [{ required: true, message: 'Please Update Name!' }],
              })(<Input placeholder={'Package Name'}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Delivery Mode">
              {getFieldDecorator('to.method', {
                initialValue: get(packageObj, 'to.method'),
                rules: rules.select,
              })(<DeliveryMode disabled={isLocked}/>)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'SUB-COMPONENT'}>
              {getFieldDecorator('isSubcomponents', {
                initialValue: get(packageObj, 'isSubcomponents'),
                valuePropName: 'checked',
              })(<Checkbox disabled={isLocked}/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'EXPORT RESTRICTED'}>
              {getFieldDecorator('isRestricted', {
                initialValue: get(packageObj, 'isRestricted'),
                valuePropName: 'checked',
              })(<Checkbox disabled={isLocked}/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'DANGEROUS GOODS'}>
              {getFieldDecorator('isDangerous', {
                initialValue: get(packageObj, 'isDangerous'),
                valuePropName: 'checked',
              })(<Checkbox disabled={isLocked}/>)}
            </Form.Item>
          </Col>
        </Row>
        {isDangerous && (
          <Row>
            <h3>
              DANGEROUS GOODS
              <Icon
                style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
                type="plus-circle"
                theme="filled"
                onClick={() => !isLocked && setGoods((prvG) => prvG + 1)}
              />
              {goods > 1 && (
                <Icon
                  style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
                  type="minus-circle"
                  theme="filled"
                  onClick={() => !isLocked && setGoods((prvG) => prvG - 1)}
                />
              )}
            </h3>
            {Array.apply(null, { length: goods })
              .map(Number.call, Number)
              .map((item) => (
                <DangerousGoodsItem
                  viewOnly={isLocked}
                  item={item}
                  quote={packageObj}
                  resetFields={resetFields}
                  getFieldValue={getFieldValue}
                  attrPrefix={''}
                  getFieldDecorator={getFieldDecorator}
                />
              ))}
          </Row>
        )}

        {isNew && (
          <>
            <Row>
              <DeliveryDetails
                title={'From Address'}
                doc={packageObj}
                {...{
                  getFieldDecorator,
                  getFieldValue,
                  setFieldsValue,
                  viewOnly: isLocked,
                  resetFields,
                  type: 'Package',
                  hideDangerous: true,
                  hideExport: true,
                  prefix: 'from',
                }}
              />
            </Row>
            <Row>
              <DeliveryDetails
                title={'To Address'}
                doc={packageObj}
                {...{
                  getFieldDecorator,
                  getFieldValue,
                  setFieldsValue,
                  resetFields,
                  viewOnly: isLocked,
                  type: 'Package',
                  hideDangerous: true,
                  hideExport: true,
                  prefix: 'to',
                }}
              />
            </Row>
          </>
        )}
        <Row>
          <ShippingDetails
            line={packageObj}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'package',
            }}
          />
        </Row>
      </Form>
    </CustomSpin>
  )
}

const DeliveryMode = compose(
  withData({
    data: [
      { value: 'Air Freight', key: 'Air Freight' },
      { value: 'Sea Freight', key: 'Sea Freight' },
      { value: 'Land Freight', key: 'Land Freight' },
      { value: 'Intermodal', key: 'Intermodal' },
    ],
  }),
  withSort,
)(CustomSelect)

PackageForm.propTypes = {}
PackageForm.defaultProps = {}

export default Form.create()((PackageForm))
